'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isRequired = function isRequired(value) {
  return value ? undefined : 'This field is required';
};

exports.default = isRequired;